import { render, staticRenderFns } from "./sensitiveWord-revise.vue?vue&type=template&id=a5b53d5c&scoped=true"
import script from "./sensitiveWord-revise.vue?vue&type=script&lang=js"
export * from "./sensitiveWord-revise.vue?vue&type=script&lang=js"
import style0 from "./sensitiveWord-revise.vue?vue&type=style&index=0&id=a5b53d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b53d5c",
  null
  
)

export default component.exports